import { type Scores } from "../vowGameLogic";

export type ScoreKey = keyof Scores;

export type ScoreMetadata = {
  key: ScoreKey;
  label: string;
  shortLabel: string;
  description: string;
};

export const SCORE_LIST: ScoreMetadata[] = [
  {
    key: "D",
    label: "Duck",
    shortLabel: "Duck",
    description: "Total ducks counted across the wetland.",
  },
  {
    key: "BHQ",
    label: "Bittern Habitat",
    shortLabel: "Bittern Habitat",
    description: "Habitat quality index for bittern nesting areas.",
  },
  {
    key: "BIO",
    label: "Biodiversity",
    shortLabel: "Biodiversity",
    description: "Composite score tracking ecosystem diversity.",
  },
  {
    key: "Births",
    label: "Births",
    shortLabel: "Births",
    description: "New hatchlings observed in the current season.",
  },
];

export const SCORE_METADATA: Record<ScoreKey, ScoreMetadata> = SCORE_LIST.reduce(
  (acc, meta) => {
    acc[meta.key] = meta;
    return acc;
  },
  {} as Record<ScoreKey, ScoreMetadata>
);

export const getScoreLabel = (key: ScoreKey): string =>
  SCORE_METADATA[key]?.label ?? key;

